<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> جزئیات مسابقه {{ matchTitle }}</template>
    <template v-if="matchDetails">
      <BRow>
        <BCol cols="12" md="6">
          <TextInput
            readonly
            inputId="matchTitle"
            inputLabel="عنوان مسابقه"
            inputPlaceholder="عنوان مسابقه"
            v-model="matchDetails.title"
          ></TextInput>
        </BCol>
        <BCol cols="12" md="6">
          <TextInput
            readonly
            inputId="matchSettingsTitle"
            inputLabel="عنوان تنظیمات مسابقه"
            inputPlaceholder="عنوان تنظیمات مسابقه"
            v-model="matchDetails.matchSettingsTitle"
          ></TextInput>
        </BCol>
        <BCol cols="12" md="6">
          <TextInput
            readonly
            inputId="matchQuestionsCount"
            inputLabel="تعداد سوال های مسابقه"
            inputPlaceholder="تعداد سوال های مسابقه"
            v-model="matchDetails.matchQuestionsCount"
          ></TextInput>
        </BCol>
        <BCol cols="12" md="6">
          <TextInput
            readonly
            inputId="matchUsersCount"
            inputLabel="تعداد شرکت کنندگان"
            inputPlaceholder="تعداد شرکت کنندگان"
            v-model="matchDetails.matchUsersCount"
          ></TextInput>
        </BCol>
        <BCol cols="12">
          <hr />
        </BCol>
        <BCol cols="12">
          <MatchQuestionList
            isDense
            :matchQuestions="matchDetails.matchQuestions"
            :selectedMatch="matchDetails"
            @refetch="getMatchDetailsById"
          ></MatchQuestionList>
        </BCol>
        <BCol cols="12">
          <hr />
        </BCol>
        <BCol cols="12">
          <MatchUsersList
            isDense
            :matchUsers="matchDetails.matchUsers"
            :selectedMatch="matchDetails"
            @refetch="getMatchDetailsById"
          ></MatchUsersList>
        </BCol>
      </BRow>
    </template>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getMatchDetailsById();
  },
  data() {
    return {
      isLoading: false,
      matchDetails: null,
    };
  },
  methods: {
    async getMatchDetailsById() {
      try {
        this.isLoading = true;
        const _this = this;
        const getMatchDetails = new GetMatchDetails(_this);
        getMatchDetails.setRequestParam({
          id: _this.$route.params.id,
        });
        await getMatchDetails.fetch((res) => {
          _this.matchDetails = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    matchTitle() {
      if (this.matchDetails && this.matchDetails.title) {
        return this.matchDetails.title;
      }
      return "";
    },
  },
  components: {
    MatchQuestionList,
    MatchUsersList,
    PageWrapper,
    TextInput,
    BRow,
    BCol,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import MatchQuestionList from "@/views/components/Matches/MatchQuestionList.vue";
import MatchUsersList from "@/views/components/Matches/MatchUsersList.vue";
import { BRow, BCol } from "bootstrap-vue";
import { GetMatchDetails } from "@/libs/Api/Matches";
</script>
